export const FieldError = ({ label }: any) => {
  return <p className="text-red-500 font-sm">{label}</p>
}
